import useBreakpoints from '@zenbusiness/zui/useBreakpoints';
import PropTypes from 'prop-types';


import CustomizedDialog from './CustomizedDialog';
import CustomizedDrawer from './CustomizedDrawer';

export default function DrawerOrDialog({ handleClose, children }) {
  const {
    sizes: { isMobile }
  } = useBreakpoints();
  if (isMobile) {
    return <CustomizedDialog handleClose={handleClose}>{children}</CustomizedDialog>;
  }

  return (
    <CustomizedDrawer
      anchor="right"
      handleClose={handleClose}
    >
      {children}
    </CustomizedDrawer>
  );
}

DrawerOrDialog.propTypes = {
  handleClose: PropTypes.func,
  children: PropTypes.node
};
